import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import * as Sentry from "@sentry/angular";

const hostname = window.location.hostname;
const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

if (!isLocalhost) {
  Sentry.init({
  dsn: "https://776da66f7cc8f4798d6fda61b4f099d8@o4507644440936448.ingest.de.sentry.io/4510815639437392",
  tracesSampleRate: environment.sentryTracesSampleRate,
  initialScope: {
    tags: {
      dashboard: "Admin",
      environment: environment.sentryEnvironment
    }
  }
});
}


if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
